/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconExclamationMarkOff = createReactComponent("outline", "exclamation-mark-off", "IconExclamationMarkOff", [["path", { "d": "M12 19v.01", "key": "svg-0" }], ["path", { "d": "M12 15v-3m0 -4v-3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconExclamationMarkOff as default };
//# sourceMappingURL=IconExclamationMarkOff.mjs.map
